import React from 'react'
import Footer from '../components/footer';
import './Gallery.css';

const Gallery = () => {
  return (
    <>
   <div class="container-10">



<div class="gallery">

    <div class="gallery-item">
        <img class="gallery-image" src="./images/im1.jpeg" alt=""/>
       
    </div>

    <div class="gallery-item">
    <img class="gallery-image" src="./images/im2.jpeg" alt=""/>
    </div>

    <div class="gallery-item">
    <img class="gallery-image" src="./images/im3.jpeg" alt=""/>
    </div>

    <div class="gallery-item">
    <img class="gallery-image" src="./images/im4.jpeg" alt=""/>
    </div>

    <div class="gallery-item">
    <img class="gallery-image" src="./images/im5.jpeg" alt=""/>
    </div>

    <div class="gallery-item">
    <img class="gallery-image" src="./images/im6.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im7.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im8.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im9.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im10.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im11.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im12.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im13.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im14.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im15.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im16.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im17.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im18.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im20.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im19.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im21.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im22.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im23.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im24.jpeg" alt=""/>
    </div>
    <div class="gallery-item">
    <img class="gallery-image" src="./images/im25.jpeg" alt=""/>
    </div>

</div>

</div>

<Footer/>
    </>
  )
}

export default Gallery